module.exports = "<header>\n  <div>\n    <img src=\"img/social-security/ministerio.png\" alt=\"{{'SOCIAL_SECURITY.HEADER_SS.MINISTRY' | translate}}\" class=\"header-image-left\" />\n    <h1>\n      <ng-transclude></ng-transclude>\n    </h1>\n    <img src=\"img/social-security/tesoreria.png\" alt=\"{{'SOCIAL_SECURITY.HEADER_SS.TREASURY' | translate}}\" class=\"header-image-right\"/>\n  </div>\n\n  <h2>\n    {{'SOCIAL_SECURITY.HEADER_SS.INDIVIDUAL_EXTRACT_NOTE' | translate}}\n  </h2>\n</header>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/social-security.module/features/socialSecurity/headerSS/headerSS.html
// module id = 2330
// module chunks = 0